/**
 * Phase 2 — Auto Loans vertical CategoryConfig.
 *
 * Single source of truth for everything auto-loan-specific that used
 * to live scattered across PartnerRateTable.jsx, RatesPanel.jsx, and
 * categoryCopy.js. See `/features/insurance/config.js` for full
 * Phase 2 rationale.
 */
export const AUTO_LOAN_CONFIG = {
  id: "auto-loan",
  label: "Auto Loans",
  singularProviderLabel: "lender",
  pluralProviderLabel: "lenders",
  providerType: "lender",

  rateTable: {
    sortOptions: ["featured", "lowest-apr", "highest-rated", "lowest-credit"],
    columns: ["lender", "apr", "credit", "loan", "term", "rating", "cta"],
    ctaLabel: "Check My Rate",
    trustLine: "Free · Soft pull · No obligation",
    headerLabel: "Today's rates",
  },

  modalCategory: "auto-loan-new",
  weeklyShoppersBenchmark: 1800,

  scoreFields: [
    { key: "score_rates", label: "Rates & APR", weight: "40%" },
    { key: "score_terms", label: "Loan terms", weight: "25%" },
    { key: "score_application", label: "Application", weight: "20%" },
    { key: "score_support", label: "Customer support", weight: "15%" },
  ],

  adminDetailsFields: [
    { key: "lender_type", label: "Lender type", type: "text", placeholder: "Bank / Credit union / Online marketplace" },
    { key: "soft_pull", label: "Soft-pull pre-qual", type: "bool" },
    { key: "funding_speed_days", label: "Avg funding speed (days)", type: "number" },
  ],

  adminTableHeader: {
    pluralNoun: "lenders",
    numericA: "APR",
    numericB: "Min FICO",
  },

  primaryCta: "Check My Rate",

  routes: [
    "/auto-loans",
    "/new-car-loans",
    "/used-car-loans",
    "/first-time-buyer-auto-loans",
    "/best-auto-loans",
    "/auto-loans/states",
    "/auto-loans/:state",
    "/auto-loans/:state/:city",
  ],

  schemaTypes: ["Product", "Review", "FAQPage", "BreadcrumbList", "Article", "AggregateRating"],

  trustBadges: ["nmls", "softPull", "credibleSoft", "lenderTreeSoft"],

  isCreditVertical: true,
};
